// *** REACT components
import React, { useEffect, useState } from 'react'
import { useHistory } from "react-router-dom";
// *** ROUTER components
//import { Link } from "react-router-dom";
// *** @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// *** core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
// *** Imagenes
import imgPago from "assets/img/img-pago.gif";
// *** Services
import { SessionActions, KiphuActions } from "services"
import Button from "components/CustomButtons/Button"

// *** Estilos
import featuresStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/featuresStyle.js";
import basicsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.js";
import { func } from 'prop-types';
const useStyles = makeStyles(basicsStyle);
const useStyles2 = makeStyles(featuresStyle);

export default function ClaveUnicaLogin({ cambioPaso }) {
  const history = useHistory();
  const classes = useStyles();
  const classes2 = useStyles2();
  const [status, setStatus] = useState(1);
  const [token, setToken] = useState('');  
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    var Codigo = params.get('token');
    setToken(Codigo);
    var i = 0
    if (Codigo!==null) {
      const interval = setInterval(() => {
        //console.log('This will run every second!');
        i++
        contador(Codigo,interval,i)
        //pruebaInterval(interval,i)
      }, 1000);
    }       
  }, []);
  function pruebaInterval(interval,i) {
    if (i===4) {
      window.clearInterval(interval)
    }
    
  }
  function contador(Codigo,interval,i) {    
    //llamar a la api para saber si se realizo el pago
    KiphuActions.ConfirmarPago(Codigo).then((response) => {
      //traer del back el status y dependiendo de eso mostrar el mensaje
      //si contiene url + status 2 entonces debe redireccionar a la url que tenga en la respuesta       
      if (response.data.status === 2 && response.data.redirectFront !== '')
      {
        window.clearInterval(interval)
        window.location.href = response.data.redirectFront
      }
      if(response.data.status===3 || response.data.status===4)
        window.clearInterval(interval)
      
      if(status!==response.data.status)
        setStatus(response.data.status) 
    })

  }
  function redirectPago() {
    KiphuActions.GeneraPago(token).then((responsePago)=>{
      window.location.href = responsePago.data     
    })
  }
  function redirectFirmadox() {
    localStorage.clear()
    SessionActions.logout()
    history.push("/")
  }
  return (
    <div>
      <div>
        <GridContainer>
          {status === 4 ?
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.title} style={{ textAlign: "center" }}>
                <h2>El cobro ha sido anulado.</h2>
                <h3>Si tiene dudas con respecto al pago no dude en enviarnos un correo a
                  <a href="mailto:soporte@firmadox.cl"> soporte@firmadox.cl</a> explicando brevemente el problema.</h3>
                <Button color="success" onClick={() => redirectFirmadox()}>Volver al sitio web de compra</Button>
              </div>
              <div>
                <img style={{ width: "700px", display: "block", marginLeft: "auto", marginRight: "auto" }} src={imgPago} alt="..." />
              </div>
            </GridItem>
            :
            <div></div>}

          {status === 3 ?
            <GridItem xs={12} sm={12} md={12}>
              <div className={classes.title} style={{ textAlign: "center" }}>
                <h2>El cobro ha sido rechazado.</h2>
                <h3>Si tiene dudas con respecto al pago no dude en enviarnos un correo a
                  <a href="mailto:soporte@firmadox.cl"> soporte@firmadox.cl</a> explicando brevemente el problema.</h3>
                <Button color="success" onClick={() => redirectPago()}>Reintentar el pago</Button>
              </div>
              <div>
                <img style={{ width: "700px", display: "block", marginLeft: "auto", marginRight: "auto" }} src={imgPago} alt="..." />
              </div>
            </GridItem>
            :
            <div></div>
          }
          {
            status !== 3 && status !== 4 ?
              <GridItem xs={12} sm={12} md={12}>
                <div className={classes.title} style={{ textAlign: "center" }}>
                  <h2>Espere un momento, estamos confirmando el pago.</h2>
                  <h2>No cierre esta página,    lo redireccionaremos automáticamente para completar su proceso de compra.</h2>
                </div>
                <div>
                  <img style={{ width: "700px", display: "block", marginLeft: "auto", marginRight: "auto" }} src={imgPago} alt="..." />
                </div>
              </GridItem>
              : <div></div>
          }

        </GridContainer>
      </div>
    </div>
  )
}
